module.exports = __webpack_public_path__ + "img/main-logo.5453dfd8.png";